/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundHistoryDtoFundingRequest
 */
export interface FundHistoryDtoFundingRequest {
  /**
   *
   * @type {string}
   * @memberof FundHistoryDtoFundingRequest
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof FundHistoryDtoFundingRequest
   */
  number: number;
  /**
   *
   * @type {Date}
   * @memberof FundHistoryDtoFundingRequest
   */
  createdAt: Date;
  /**
   *
   * @type {string}
   * @memberof FundHistoryDtoFundingRequest
   */
  name: string;
}

export function FundHistoryDtoFundingRequestFromJSON(json: any): FundHistoryDtoFundingRequest {
  return FundHistoryDtoFundingRequestFromJSONTyped(json, false);
}

export function FundHistoryDtoFundingRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FundHistoryDtoFundingRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    createdAt: new Date(json["createdAt"]),
    name: json["name"],
  };
}

export function FundHistoryDtoFundingRequestToJSON(value?: FundHistoryDtoFundingRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    createdAt: value.createdAt.toISOString(),
    name: value.name,
  };
}
